import { useTranslation } from "react-i18next";
import SearchExternalUsersReportCard from "../../../components/card/SearchExternalUsersReportCard";
import { useState } from "react";
import ExternalUsersReportTable from "../../../components/table/ExternalUsersReportTable";
import BackButtonWrapper from "../../../components/button/BackButton/wrapper";
import { ExportExternalUsersReportForExcelPDFBody } from "../../../hooks/report/interface";
import { PAGE_SIZE } from "../../../constants/common";

const ExternalUsersReport = () => {
  const { t } = useTranslation();

  const [exportBody, setExportBody] =
    useState<ExportExternalUsersReportForExcelPDFBody>();
  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);
  const [search, setSearch] = useState("");

  const [allExternalUsers, setAllExternalUsers] = useState([]);

  return (
    <div className="flex flex-col gap-4 md:gap-8">
      <BackButtonWrapper>
        <h1 className="text-xl md:text-2xl dark:text-white">
          {t("externalUsersReport")}
        </h1>
      </BackButtonWrapper>

      <SearchExternalUsersReportCard
        setAllExternalUsers={setAllExternalUsers}
        page={page}
        search={search}
        setPages={setPages}
        setCount={setCount}
        setExportBody={setExportBody}
        pageSize={pageSize}
        setPage={setPage}
      />

      <ExternalUsersReportTable
        allExternalUsers={allExternalUsers}
        page={page}
        pages={pages}
        setPage={setPage}
        search={search}
        setSearch={setSearch}
        count={count}
        exportBody={exportBody}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default ExternalUsersReport;
